export default __webpack_public_path__ + "static/media/Snd_CU.b54f4ee4.mp3";